import { Injectable, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SwitchOrganizationsService implements OnInit {

  centralToken:any = '';
  private typeObj: Subject<void> = new Subject<void>();
  constructor(private _auth:AuthService,) { }

    ngOnInit(): void {
    }
  setCentralToken(){
    this.centralToken = this._auth.getCookie('fiGalaxyTokencentralThirdParties');
  }

  removeCentralToken(){
    this.centralToken = '';
  }

  invokeUpdatedType(active_company:any) {
    this.typeObj.next(active_company);
  }

  getUpdatedTypeObservable() {
    return this.typeObj.asObservable();
  }

}
